<template>
  <div class="w-100 h-100 m-0 position-relative d-flex flex-column align-items-center" style="padding: 32px">
    <div class="row m-0 p-0 acry-page-title justify-content-center">アンケートありがとうございました</div>
    <div class="mb-0" style="margin-top:63px; font-size: 16px; width:552px;">
      <p class="m-0">受け付け完了メールが届くまでしばらくお待ちください。</p>
    </div>

    <div class="mb-0 d-flex flex-column align-items-center" style="margin-top:63px; width:868px; background:#F8F8F8; padding:24px 16px;">
      <p class="fw-bold" style="margin-bottom:16px; ">注意事項</p>
      <div class="m-auto d-flex flex-column text-start">
        <p class="m-0" style="font-size: 13px;">・完了メールはsystem@acry.jpからお送りします</p>
        <p class="m-0" style="font-size: 13px;">・メールが届かない場合は、メールアドレスが間違っているか、迷惑メールフォルダに届いてしまっている可能性があります。</p>
      </div>
    </div>


    <button class="mx-0 acry-btn fw-bold" style="width: 240px; height: 56px; border-radius: 100px; font-size: 16px; margin-top:40px;" @click="clickReturnBtn">
      TOPに戻る
    </button>
  </div>
</template>

<script>
import { CenterViewState } from "@/js/Const.js";

export default {
  name: "CenterViewFirstTimeFreeSurveyComplete_Ap",
  props: {},
  data: function () {
    return {
      selectSize:"S",
    };
  },
  computed: {},
  created() {
  },
  components: {},
  methods: {
    clickReturnBtn(){
      this.$store.commit("setCenterViewState", CenterViewState.Upload);
      // this.$store.commit('setRightViewState', RightViewState.FirstTimeFreeUpload);
    }
  },
};
</script>

<style scoped lang="scss">

</style>
